export const ADMIN = 'admin';
export const VIEWER = 'viewer';
export const EDITOR = 'editor';
export const SUPPORT = 'support';
export const FINANCE = 'finance';
